import React from "react";

const Footer = () => {
  return (
    <footer id="contact" className="bg-gray-900 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <h5 className="text-xl font-bold mb-2">need2know Platform</h5>
            <p className="text-gray-300">
              Government Contract Intelligence System
            </p>
          </div>
          <div className="text-center md:text-right">
            <p className="text-gray-400">
              &copy; 2025 need2know. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
